import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class LogicGreaterThanParam extends DesigntimeComponent {
    static staticName = "Logic: Greater than (param)";
    static staticId = "logicGreaterThanParam";
    hasRuntimeView = false;

    constructor(identifyer) {
        super(identifyer, 1);
        this.values = {};
        this.params = {
            parameter1: { key: "url:monthlySpending", value: 0 },
            parameter2: { key: "url:monthlySpending", value: 0 }
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));
        return $("<div class='logicGreaterThanParam'></div>");
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == this.id)
            return;

        if (eventParams.key == this.params.parameter1.key)
            this.params.parameter1.value = Number(eventParams.value);
        else if (eventParams.key == this.params.parameter2.key)
            this.params.parameter2.value = Number(eventParams.value);
        else
            return;

        var res = this.params.parameter1.value < this.params.parameter2.value;

        this.eventBroker.fireValueChanged(this.id, "value", res);
        this.eventBroker.fireValueChanged(this.id, "not_value", !res);
    }

    output = [
        { name: "value", type: "bool" },
        { name: "not_value", type: "bool" }
    ];
}

export { LogicGreaterThanParam }
